import { FieldValues } from "react-hook-form";

import { FieldSchema } from "@/components/section";

export function flattenFormSchemaGroups<TFormValues extends FieldValues, TRecord>(
  formSchema: FieldSchema<TFormValues, TRecord>[]
) {
  const flattenedFormSchema: FieldSchema<TFormValues, TRecord>[] = [];

  for (const fieldSchema of formSchema) {
    flattenedFormSchema.push(fieldSchema);
  }

  return flattenedFormSchema;
}
